module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Medium-aec38a6b266a908bc320e30f261771d1.woff2";